<mat-card class="padding">
  <mat-card-content>
    <div class="tab-content">
      <div class="scheduling-report-container">
        <div class="input-container">
          <div class="input-fields-wrapper">
            <div class="input-wrapper">
              <div class="row alignment" style="width: 100%;">
                <div class="col-lg-1 alignment">
                  <button mat-flat-button color="" class="btn-flat" [ngClass]="lastDays == '30' ? 'selected':''" (click)="last30Days()">{{'subscription.btn1' | translate}}</button>
                </div>
                <div class="col-lg-1 alignment">
                  <button mat-flat-button color="" class="btn-flat" [ngClass]="lastDays == '90'  ? 'selected':''" (click)="last90Days()">{{'subscription.btn2' | translate}}</button>
                </div>
                <div class="col-lg-9 alignment date">
                  <span class="span">
                    {{'subscription.dateFrom' | translate}}
                  </span>
                  <mat-form-field class="aaa example-full-width custom-date-picker " appearance="fill">
                    <input matInput placeholder="From Date" [matDatepicker]="picker" [(ngModel)]='startDate' readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <span class="span">
                    {{'subscription.dateTo' | translate}}
                  </span>
                  <mat-form-field class="example-full-width-2 custom-date-picker" appearance="fill">
                    <input type="text" matInput placeholder="To Date" [matDatepicker]="picker1" [(ngModel)]='endDate' readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <!-- <span>
                    Stat Date
                  </span>
                  <input type="date" [ngModel]="startDate | date:'yyyy-MM-dd'" (ngModelChange)="startDate = $event"
                    class="w-25 margin-input form-control ng-pristine ng-untouched ng-valid">
                  <span>
                    End Date
                  </span>
                  <input type="date" [ngModel]="endDate | date:'yyyy-MM-dd'" (ngModelChange)="endDate = $event"
                    class="w-25 form-control ng-pristine ng-untouched ng-valid"> -->
                </div>
                <div class="col-lg-1 alignment text-right">
                  <button mat-flat-button color="" class="btn-primary " (click)="getPurchaseHistory('search')">{{'subscription.btnSearch' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container mt-0">
          <table [dataSource]="purchase" *ngIf="!noDataFound" mat-table class="mat-elevation-z8">
            <ng-container matColumnDef="Transaction Id">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabPurchaseHist.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row"> {{row.transactionID}}</td>
            </ng-container>
            <ng-container matColumnDef="Credits Purchased">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabPurchaseHist.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.creditsPurchased}}</td>
            </ng-container>
            <ng-container matColumnDef="Purchased data">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'subscription.TabPurchaseHist.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.purchaseDate | date}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayed sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayed;"></tr>
          </table>
          <div class="data-not-found-container" *ngIf='noDataFound && lastDays == "30"'>
            <p>{{'subscription.errorMsg1' | translate}}</p>
          </div>
          <div class="data-not-found-container" *ngIf='noDataFound && lastDays == "90"'>
            <p>{{'subscription.errorMsg2' | translate}}</p>
          </div>
          <div class="data-not-found-container" *ngIf='noDataFound && lastDays == ""'>
            <p>{{'subscription.errorMsg3' | translate}}</p>
          </div>
        </div>
        <div class="purchase-paginator" [ngClass]="{'hidden': showPaginator === false}">
          <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
